import { Button } from '@telegram-apps/telegram-ui'
import { useTranslate } from 'shared/lib/i18n'

export type SlotStatus = 'free' | 'paid'
export interface Slot {
	id: string
	name: string
	status: SlotStatus
	isMine: boolean
}

export function SizeGrid({
	slots,
	selectedSlotIds,
	disabled = false,
	onSelect,
}: {
	slots: Slot[]
	selectedSlotIds: Set<string>
	disabled?: boolean
	onSelect: (id: string) => void
}) {
	const { t } = useTranslate()
	return (
		<div className='grid grid-cols-3 gap-2'>
			{slots.map((slot) => {
				const isFree = slot.status === 'free'
				const isSelected = isFree && selectedSlotIds.has(slot.id)
				const isMine = !isFree && slot.isMine
				return (
					<Button
						// A lot may hold duplicate names, so selection is per stable slot.
						key={slot.id}
						size='m'
						mode={
							!isFree
								? isMine
									? 'filled'
									: 'gray'
								: isSelected
									? 'filled'
									: 'bezeled'
						}
						className={isMine ? 'bg-green-600!' : undefined}
						disabled={disabled || !isFree}
						stretched
						onClick={() => !disabled && isFree && onSelect(slot.id)}
					>
						<span className='flex flex-col leading-tight'>
							<span className='text-base font-semibold'>{slot.name}</span>
							{!isFree && (
								<span className='text-xs opacity-70'>
									{isMine ? t('pages.lot.yourSlot') : t('pages.lot.sold')}
								</span>
							)}
						</span>
					</Button>
				)
			})}
		</div>
	)
}
